<template>
  <v-dialog max-width="600" v-model="dialog" @keydown.enter.prevent="onenter">
    <v-card>
      <v-card-title>
        <span class="headline"> HUB Event ({{ this.rules.name }})</span>
      </v-card-title>
      <v-card-text>
        <v-row dense class="mb-4">
          <v-col cols="12" md="12" sm="12">
            <v-text-field disabled label="UID:" v-model.trim="model.uid" hide-details outlined dense/>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field
                label="Name"
                v-model.trim="model.name"
                v-ascii-only
            />
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field
                label="Key"
                v-model.trim="model.key"
                v-ascii-only
            />
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <r-product-dropdown :model.sync="model.productBonus" label="Product Bonus" :clearable="true"/>
          </v-col>
        </v-row>
        <v-expansion-panels>
          <r-panel title="Settings">
            <v-row dense>
              <v-col cols="12" sm="4" md="4">
                <v-text-field v-model.number="model.iconBadgeExpires" label="Icon Badge Expires" hide-details/>
              </v-col>
            </v-row>
          </r-panel>
          <r-guard-panel :model.sync="model.guard" title="Guard Config"/>
          <r-guard-money-panel :model.sync="model.guardMoney" title="Guard Money"/>
        </v-expansion-panels>

        <v-row dense class="pt-6">
          <v-expansion-panels>
            <r-reward-track-panel :model.sync="model.rewardTrack" title="Rewards" label="Rewards" :points="true"/>
          </v-expansion-panels>
        </v-row>

        <v-row dense class="pt-6">
          <v-expansion-panels>
            <r-product-track-panel :model.sync="model.productTrack" title="Products Track" label="Products" :points="true"/>
          </v-expansion-panels>
        </v-row>

        <v-row dense class="pt-6">
          <v-expansion-panels>
            <r-panel title="Event Offers">
              <v-row dense v-for="(offer, index) in model.eventOffers" :key="`event-${index}`" align="center">
                <v-col cols="10">
                  <v-text-field 
                    v-model="model.eventOffers[index]" 
                    :label="`Event Offer ${index + 1}`"
                    v-ascii-only
                    outlined
                    dense/>
                </v-col>
                <v-col cols="2">
                  <v-btn icon small color="red" @click="removeEventOffer(index)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row dense class="pt-2">
                <v-col>
                  <v-btn small color="primary" @click="addEventOffer">
                    <v-icon small left>mdi-plus</v-icon>
                    Add Event Offer
                  </v-btn>
                </v-col>
              </v-row>
            </r-panel>
          </v-expansion-panels>
        </v-row>

        <v-row dense class="pt-6">
          <v-expansion-panels>
            <r-panel title="Shop Offers">
              <v-row dense v-for="(offer, index) in model.shopOffers" :key="`shop-${index}`" align="center">
                <v-col cols="10">
                  <v-text-field 
                    v-model="model.shopOffers[index]" 
                    :label="`Shop Offer ${index + 1}`"
                    v-ascii-only
                    outlined
                    dense/>
                </v-col>
                <v-col cols="2">
                  <v-btn icon small color="red" @click="removeShopOffer(index)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row dense class="pt-2">
                <v-col>
                  <v-btn small color="primary" @click="addShopOffer">
                    <v-icon small left>mdi-plus</v-icon>
                    Add Shop Offer
                  </v-btn>
                </v-col>
              </v-row>
            </r-panel>
          </v-expansion-panels>
        </v-row>

      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {ViewRules} from "@/common/ViewRules";
import {SmartOfferBundleHub} from "@/modules/redactor/models/smart-offer/bundle-hub/SmartOfferBundleHub";

import RGuardPanel from "@/modules/redactor/views/guard/r-guard-panel.vue";
import RGuardMoneyPanel from "@/modules/redactor/views/guard/r-guard-money-panel.vue";
import RRewardTrackPanel from "@/modules/redactor/views/reward/r-reward-track-panel.vue";
import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RProductDropdown from "@/modules/redactor/views/product/r-product-dropdown.vue";
import RProductTrackPanel from "@/modules/redactor/views/product/r-product-track-panel.vue";

export default {
  name: "r-smart-offer-bundle-hub",
  components: {
    RPanel,
    RRewardTrackPanel,
    RGuardMoneyPanel,
    RGuardPanel,
    RProductDropdown,
    RProductTrackPanel
  },
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    tab: null,
    model: new SmartOfferBundleHub(),
    rules: ViewRules.READONLY,
  }),
  computed: {
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.tab = null;
      this.rules = rules;
      this.model = model || new SmartOfferBundleHub();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    },
    onenter() {
      this.save();
    },
    addEventOffer() {
      this.model.eventOffers.push("");
    },
    removeEventOffer(index) {
      this.model.eventOffers.splice(index, 1);
    },
    addShopOffer() {
      this.model.shopOffers.push("");
    },
    removeShopOffer(index) {
      this.model.shopOffers.splice(index, 1);
    }
  }
}
</script>
